/**
 * This module has been forked off of the InstanceStatus component.
 * The the behaviour of database statuses indicator diverges from instance status incidactor.
 * At present, the implementation is minimal.
 * Improve over time as needed.
 */
import { Label, LoadingSpinner, Typography } from '@neo4j-ndl/react';
import type { AuraDatabase } from '@nx/state';
import { INSTANCE_STATUS, ONLINE_STATUS } from '@nx/state';
import cx from 'classnames';

const databaseStatusText = (database: AuraDatabase) => {
  switch (database.status) {
    default:
      return database.status;
  }
};

export const getDatabaseOnlineStatus = (database: AuraDatabase) => {
  switch (database.status) {
    default:
      return ONLINE_STATUS.ONLINE;
  }
};

const onlineStatusColor = (status: ONLINE_STATUS) => {
  switch (status) {
    case ONLINE_STATUS.ONLINE:
      return 'success';
    case ONLINE_STATUS.DEGRADED:
      return 'warning';
    case ONLINE_STATUS.OFFLINE:
      return 'default';
    default:
      return 'default';
  }
};

interface Props {
  database: AuraDatabase;
}

export const DatabaseStatus = ({ database }: Props) => {
  const showLoadingSpinner = [
    INSTANCE_STATUS.DESTROYING,
    INSTANCE_STATUS.CREATING,
    INSTANCE_STATUS.RESUMING,
    INSTANCE_STATUS.PAUSING,
  ].includes(database.status);

  const statusText = databaseStatusText(database);

  if (showLoadingSpinner) {
    return (
      <span className="flex h-6 flex-row items-center gap-1 uppercase tracking-normal">
        <LoadingSpinner aria-label={`Database is ${statusText}`} />
        <Typography variant="body-medium">{statusText}</Typography>
      </span>
    );
  }

  return (
    <Label
      fill="clean"
      hasIcon
      color={onlineStatusColor(getDatabaseOnlineStatus(database))}
      className={cx('truncate font-normal uppercase [&_.ndl-icon-svg]:shrink-0', {
        '[&_.ndl-label-text]:!text-success-text': database.status === INSTANCE_STATUS.RUNNING,
        '[&_.ndl-label-text]:!text-neutral-text-weaker': database.status === INSTANCE_STATUS.PAUSED,
      })}
    >
      {statusText}
    </Label>
  );
};
